import React, { useMemo } from "react";

import { useCustomerPortalContext } from "Context/CustomerPortalContext";
import {
  CustomerPortalJobProvider,
  useCustomerPortalJobContext,
} from "Context/CustomerPortalJobContext";
import ReactDOM from "react-dom";

import { SubHeader } from "../CustomerPortalHeader/SubHeader";
import { OrderPagePopups } from "./OrderPagePopups";
import { OrderTabRightComponent } from "./OrderTabRightComponent";
import { OrderTabs } from "./OrderTabs";
import { OrderWindows } from "./OrderWindows";
import { Wrapper } from "./styled";
import { TabSelected, useOrderPageTabs } from "./useOrderPageTabs";

export const OrderPageComp = () => {
  const { currentTab, leftPanels, setCurrentTab } = useOrderPageTabs();
  const { milestonesSteps } = useCustomerPortalJobContext();
  const { setInitialShipmentId } = useCustomerPortalContext();

  const tabs = useMemo(() => {
    return leftPanels.map((panel) => ({
      name: panel.menuItem!,
      value: panel.key!,
      render: panel.render,
    }));
  }, [leftPanels, currentTab]);

  const headerComponent = document.getElementById("header");

  return (
    <Wrapper>
      {headerComponent &&
        ReactDOM.createPortal(
          <SubHeader
            milestonesSteps={milestonesSteps}
            onOpenShipment={(shipmentId) => {
              setInitialShipmentId(shipmentId);
              setCurrentTab(3);
            }}
          />,
          headerComponent
        )}

      <OrderTabs
        currentTab={currentTab}
        tabs={tabs}
        onCurrentTabChange={setCurrentTab}
        rightComponent={
          <OrderTabRightComponent currentTabName={tabs?.[currentTab]?.name as TabSelected} />
        }
      />

      <OrderWindows currentTab={currentTab} tabs={tabs} setCurrentTab={setCurrentTab} />

      <OrderPagePopups />
    </Wrapper>
  );
};

export const OrderPage = () => {
  return (
    <CustomerPortalJobProvider>
      <OrderPageComp />
    </CustomerPortalJobProvider>
  );
};
